import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Box, themeGet, sx } from '../..';
/**
 * Skeleton states are simplified versions of components used on an initial page load to indicate that the information on the page has not fully loaded yet.
 *
 * They should only appear for only a few seconds, disappearing once components and content populate the page.
 *
 */
const Skeleton = ({
  children,
  height,
  width,
  appearance,
  testId,
  sx: sxProp,
  animated = true,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(AnimatedBox, {
    height: height,
    width: width,
    appearance: appearance,
    animated: animated,
    "data-testid": testId,
    sx: sxProp
  }, children)));
};
const shimmer = keyframes(["0%{background-position:200% 0}to{background-position:-200% 0}"]);
const Wrapper = styled(Box).withConfig({
  displayName: "Skeleton__Wrapper",
  componentId: "sc-q0x98f-0"
})(["position:relative;overflow:hidden;"]);
const AnimatedBox = styled(Box).withConfig({
  displayName: "Skeleton__AnimatedBox",
  componentId: "sc-q0x98f-1"
})(["--stop-2:", ";--stop-1:", ";display:block;position:relative;border-radius:", ";margin-bottom:8px;width:", ";height:", ";background-color:", ";animation:none;@media (prefers-reduced-motion:no-preference){animation-name:", ";animation-duration:8s;animation-timing-function:ease-in-out;animation-delay:0;animation-iteration-count:infinite;animation-direction:normal;animation-fill-mode:none;animation-play-state:", ";}background-image:linear-gradient(270deg,var(--stop-1),var(--stop-2),var(--stop-2),var(--stop-1));background-size:400% 100%;", ""], themeGet('colors.skeleton.default'), themeGet('colors.surface.default'), p => p.appearance && p.appearance === 'round' ? '50%' : p.appearance && p.appearance === 'square' ? '0px!important' : p.appearance && p.appearance === 'pill' ? '99999px' :
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
p.appearance && p.appearance === 'default' ? themeGet('radii.1') : themeGet('radii.1'), p => p.width ? p.width + 'px' : 'revert', p => p.appearance && p.width && p.appearance === 'round' ? 'p.width' : p.height ? p.height + 'px' : '40px', themeGet('colors.skeleton.default'), shimmer, p => p.animated === false ? 'paused' : 'running', sx);
Skeleton.displayName = 'Skeleton';
export default Skeleton;